import React, { useContext, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { LangContext } from "../../LanguageProvider";
import { Document, Page, pdfjs } from "react-pdf";

// Set up the worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Otchet20242025 = () => {
  const { translations } = useContext(LangContext);
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(
    window.innerWidth > 600 ? 600 : window.innerWidth - 40,
  );

  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth > 600 ? 600 : window.innerWidth - 40);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <Box
      sx={{
        fontSize: "16px",
        padding: 0,
        maxWidth: "100%",
        marginTop: "100px",
        marginBottom: "100px",
        userSelect: "none", // CSS prevention
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
      onContextMenu={e => e.preventDefault()} // Disable context menu
    >
      {/* Page Header */}
      <Box
        sx={{
          marginBottom: 2,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontSize: "26px", textAlign: "center" }}>
          {translations["otchet"] || "Отчет 2024-2025"}
        </Typography>
        <Typography
          sx={{ fontSize: "12px", color: "text.secondary", marginTop: 1 }}>
          11.12.2025
        </Typography>
      </Box>

      {/* PDF Viewer */}
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Document
          file="/otchet20242025.pdf"
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Typography>Загрузка...</Typography>}
          error={<Typography color="error">Ошибка загрузки.</Typography>}>
          {Array.from(new Array(numPages), (el, index) => (
            <Box
              key={`page_${index + 1}`}
              sx={{ marginBottom: "20px", boxShadow: 3 }}>
              <Page
                pageNumber={index + 1}
                width={pageWidth}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Box>
          ))}
        </Document>
      </Box>
    </Box>
  );
};

export default Otchet20242025;
